import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import queryString from 'query-string';

import InvoiceList from '../../components/invoices/InvoiceList';
import ReactPaginate from 'react-paginate';
import Spinner from '../../components/generics/Spinner';
import Filter from '../../components/generics/Filter';
import ListHeader from '../../components/generics/ListHeader';

import { STARTING_PAGE } from '../../constants/constants';

import {
  fetchVendors,
  fetchVendorsSuccess,
  fetchVendorsFailure,
  fetchInvoices,
  fetchInvoicesSuccess,
  fetchInvoicesFailure,
} from "../../store/invoices/actions";
import { withRouter } from "utils/WithRouter";

export class InvoiceListContainer extends Component {
  // ---------------------------------------------------------------------------
  // Initialization
  // ---------------------------------------------------------------------------
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      invoiceNumber: '',
      invoiceDate: '',
      invoiceVendor: undefined,

    }

    this.debounceSearch = _.debounce(this.filterList, 300);
  }

  componentDidMount(){
    const params = queryString.parse(this.props.location.search);
    const invoiceDate = params.date ? params.date : '';
    const invoiceNumber = params.invoice ? params.invoice : '';
    const invoiceVendor = params.vendor ? params.vendor : undefined;
    const page = params.page ? params.page : STARTING_PAGE;

    this.setState({ page, invoiceVendor, invoiceNumber, invoiceDate}, () => {
      this.props.fetchInvoices(page, invoiceNumber, invoiceDate, invoiceVendor);
    });

    if (this.props.vendorsList.vendors.length === 0){
      this.props.fetchVendors();
    }
  }

  // ---------------------------------------------------------------------------
  // Filters
  // ---------------------------------------------------------------------------
  onDateChange = (event) => {
    let invoiceDate = event.target.value ? event.target.value : '';
    this.setState({ invoiceDate, page: STARTING_PAGE }, () => {
      this.filterList();
    });
  };

  onInvoiceNumberChange = (event) => {
    let invoiceNumber = event.target ? event.target.value : '';
    this.setState({ invoiceNumber, page: STARTING_PAGE }, () => {
      this.debounceSearch();
    });
  };

  onVendorChange = (event) => {
    let invoiceVendor = event.target.value && event.target.value > -1 ? event.target.value : undefined;
    this.setState({ invoiceVendor, page: STARTING_PAGE }, () => {
      this.filterList();
    });
  };

  filterList = () => {
    let params = {};
    if (this.state.invoiceNumber){
      params.invoice = this.state.invoiceNumber;
    }
    if (this.state.invoiceDate){
      params.date = this.state.invoiceDate;
    }
    if (this.state.invoiceVendor){
      params.vendor = this.state.invoiceVendor;
    }
    params.page = this.state.page;
    this.props.history.push({
      search: queryString.stringify(params)
    });
    this.props.fetchInvoices(this.state.page,
                             this.state.invoiceNumber,
                             this.state.invoiceDate,
                             this.state.invoiceVendor);
  };

  // ---------------------------------------------------------------------------
  // Pagination
  // ---------------------------------------------------------------------------
  handlePageRequest = (data) => {
    let page = data.selected + 1;
    if(page !== this.state.page){
      this.setState({ page }, () => {
          this.filterList();
      });
    };
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render() {
    if(!this.props.invoicesList.invoices){
      return(
        <Spinner />
      )
    }
    return (
      <div className="animated fadeIn">
        <div className="card">
          <ListHeader title="Invoices"
                      iconClass="fa fa-file-text-o mr-05"
                      actionLink={'/invoice/new'} />

          <Filter
            searchLabel="Invoice Number"
            searchPlaceholder="Invoice number"
            searchVal={this.state.invoiceNumber}
            onSearchChange={this.onInvoiceNumberChange}
            dateLabel="Invoice Date"
            dateVal={this.state.invoiceDate}
            onDateChange={this.onDateChange}
            dropdownLabel="Vendor"
            dropdownPlaceholder="Select vendor"
            dropdownVal={this.state.invoiceVendor}
            onDropdownChange={this.onVendorChange}
            dropdownByElementId
            dropdownOptions={this.props.vendorsList.vendors.results}
          />
        </div>
        <div className="card">
          <div className="card-block p-0">
            <table className="table table-striped table-bordered datatable mb-0">
              <thead>
                <tr>
                  <th>Invoice number</th>
                  <th className="hidden-xs-down">Status</th>
                  <th>Vendor</th>
                  <th className="hidden-xs-down">Invoice Date</th>
                  <th className="hidden-xs-down">User</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <InvoiceList invoices={this.props.invoicesList}/>
            </table>
            {this.props.invoicesList.pages > 1 &&
              <ReactPaginate pageCount={this.props.invoicesList.pages}
                             pageRangeDisplayed={2}
                             marginPagesDisplayed={1}
                             previousLabel="<"
                             nextLabel=">"
                             onPageChange={this.handlePageRequest}
                             initialPage={this.state.page-1}
                             disableInitialCallback={true}
                             containerClassName="pagination"
                             pageClassName="page-item"
                             pageLinkClassName="page-link"
                             activeClassName="page-item active"
                             previousClassName="paginate_button previous"
                             nextClassName="paginate_button next"
                             disabledClassName="page-item disabled"
                             forcePage={this.state.page-1}/>
            }
          </div>
        </div>
        {this.props.invoicesList.loading ?
          <Spinner />
        :
          null
        }
      </div>
    );
  }
};

const mapStateToProps = (state, ownProps) => {
  return {
    invoicesList: state.invoices.invoicesList,
    vendorsList: state.invoices.vendorsList
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchInvoices: (page, invoiceNumber, invoiceDate, invoiceVendor) => {
      dispatch(fetchInvoices(page, invoiceNumber, invoiceDate, invoiceVendor)).payload.then((response) => {
        dispatch(fetchInvoicesSuccess(response.data))
      }, (error) => {
        dispatch(fetchInvoicesFailure(error));
      });
    },
    fetchVendors: (props) => {
      dispatch(fetchVendors()).payload.then((response) => {
        dispatch(fetchVendorsSuccess(response.data))
      }, (error) => {
        dispatch(fetchVendorsFailure(error));
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InvoiceListContainer));
